((Drupal) => {
  Drupal.behaviors.ouigoBloc1ColonneVideo = {
    attach: (context) => {
      const wrappers = context.querySelectorAll('.bloc-1-colonne__video-ratio:not([data-video-bound])');

      wrappers.forEach((wrapper) => {
        wrapper.setAttribute('data-video-bound', 'true');
        const video = wrapper.querySelector('.bloc-1-colonne__video');
        const btn = wrapper.querySelector('.bloc-1-colonne__play-btn');
        const fullscreenBtn = wrapper.querySelector('.bloc-1-colonne__fullscreen-btn');

        if (!video || !btn) return;

        let isPlaying = false;

        const setPlaying = () => {
          isPlaying = true;
          btn.setAttribute('aria-pressed', 'true');
          btn.setAttribute('aria-label', Drupal.t('Pause the video'));
        };
        const setPaused = () => {
          isPlaying = false;
          btn.setAttribute('aria-pressed', 'false');
          btn.setAttribute('aria-label', Drupal.t('Play the video'));
        };

        video.addEventListener('play', setPlaying);
        video.addEventListener('pause', setPaused);
        video.addEventListener('ended', setPaused);

        btn.addEventListener('click', (event) => {
          event.preventDefault();
          if (isPlaying) {
            video.pause();
          } else {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {
                setPaused();
              });
            }
          }
        });

        if (video.paused) {
          setPaused();
        } else {
          setPlaying();
        }

        if (fullscreenBtn) {
          fullscreenBtn.addEventListener('click', (event) => {
            event.stopPropagation();
            event.preventDefault();
            if (video.requestFullscreen) {
              video.requestFullscreen();
            } else if (video.webkitRequestFullscreen) {
              video.webkitRequestFullscreen();
            } else if (video.webkitEnterFullscreen) {
              video.webkitEnterFullscreen();
            }
          });
        }
      });
    },
  };
})(Drupal);